import { render, staticRenderFns } from "./IconAddItem.vue?vue&type=template&id=fc03dce8"
import script from "./IconAddItem.vue?vue&type=script&lang=js"
export * from "./IconAddItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports